import React, { Component } from "react";
class Element extends Component {
    componentDidMount() {
        document
            .querySelector("body")
            .addEventListener("keypress", this.handleClick);
    }

    // returnFirstElement=(pirveliaso,pirvelgilak,meoreiaso,meoregilak, type)=>{
    //     let elementToShow = {};
    //     let number = Math.floor(Math.random()*2);
    //     if(number === 0){
    //         elementToShow.char = pirveliaso;
    //         elementToShow.realAnswer = pirvelgilak;
    //     }
    //     else{
    //         elementToShow.char = meoreiaso;
    //         elementToShow.realAnswer = meoregilak;
    //     }
    //     elementToShow.type = type;
    //     return elementToShow;
    // };

    // returnSecondElement = (mesameaso,mesamegilak, meotxeaso, meotxegilak, type)=>{
    //     let elementToShow = {};
    //     let number = Math.floor(Math.random()*2);
    //     if(number === 0){
    //         elementToShow.char = mesameaso;
    //         elementToShow.realAnswer = mesamegilak;
    //     }
    //     else{
    //         elementToShow.char = meotxeaso;
    //         elementToShow.realAnswer = meotxegilak;
    //     }
    //     elementToShow.type = type;
    //     return elementToShow;

    // };

    // returnThirdElement = (pirveliaso,pirvelgilak,meoreiaso,meoregilak,mesameaso,mesamegilak,meotxeaso,meotxegilak,type)=>{
    //     let elementToShow = {};
    //     let number = Math.floor(Math.random()*4);
    //     if(number === 0){
    //         elementToShow.char = pirveliaso;
    //         elementToShow.realAnswer = pirvelgilak;
    //     }
    //     if(number === 1){
    //         elementToShow.char = meoreiaso;
    //         elementToShow.realAnswer = meoregilak;
    //     }

    //     if(number === 2){
    //         elementToShow.char = mesameaso;
    //         elementToShow.realAnswer = mesamegilak;
    //     }
    //     if(number === 3){
    //         elementToShow.char = meotxeaso;
    //         elementToShow.realAnswer = meotxegilak;
    //     }
    //     elementToShow.type = type;
    //     return elementToShow;
    // };

    // returnElementByType=(attributes)=>{
    //     console.log(attributes);
    //     const {type,pirveliaso,pirvelgilak,meoreiaso,meoregilak,mesameaso,mesamegilak,meotxeaso,meotxegilak} = {...attributes}
    //     switch(type){
    //         case 'type1' : return(this.returnFirstElement(pirveliaso,pirvelgilak,meoreiaso,meoregilak,'type1'));
    //         case 'type2' : return(this.returnSecondElement(mesameaso,mesamegilak, meotxeaso, meotxegilak, 'type2'));
    //         case 'type3' : return(this.returnThirdElement(pirveliaso,pirvelgilak,meoreiaso,meoregilak,mesameaso,mesamegilak,meotxeaso,meotxegilak, 'type3'));
    //     }
    // }

    handleClick = event => {
        if (event.keyCode != 32) {
            const {
                attributes,
                startTime,
                timeOut,
                automaticAnswer,
                element
            } = {
                ...this.props
            };
            // const element = this.returnElementByType(attributes);
            this.props.fillAnswer(
                event.key ? event.key : "",
                startTime,
                element.realAnswer,
                automaticAnswer,
                timeOut,
                attributes.pirveliaso,
                attributes.pirvelgilak,
                attributes.meoreiaso,
                attributes.meoregilak,
                attributes.mesameaso,
                attributes.mesamegilak,
                attributes.meotxeaso,
                attributes.meotxegilak,
                element.type,
                element.char
            );
            document
                .querySelector("body")
                .removeEventListener("keypress", this.handleClick);
        }
    };

    render() {
        const { attributes, startTime, timeOut, automaticAnswer, element } = {
            ...this.props
        };
        // const element = this.returnElementByType(attributes);
        if (element) {
            if (automaticAnswer) {
                this.props.fillAnswer(
                    "",
                    startTime,
                    element.realAnswer,
                    automaticAnswer,
                    timeOut,
                    attributes.pirveliaso,
                    attributes.pirvelgilak,
                    attributes.meoreiaso,
                    attributes.meoregilak,
                    attributes.mesameaso,
                    attributes.mesamegilak,
                    attributes.meotxeaso,
                    attributes.meotxegilak,
                    element.type,
                    element.char
                );
                document
                    .querySelector("body")
                    .removeEventListener("keypress", this.handleClick);
            }
        }

        return <React.Fragment>{element ? element.char : ""}</React.Fragment>;
    }
}

export default Element;
